// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const cardSuccess = "StepIndicator__cardSuccess__PKhCJ";
export const exclamation = "StepIndicator__exclamation__WzBRx";
export const checkStep = "StepIndicator__checkStep__bO-gR";
export const stepCompleted = "StepIndicator__stepCompleted__t9FJQ";
export const stepIndicator = "StepIndicator__stepIndicator__6Xsr5";
export const value = "StepIndicator__value__guPcF";